// Custom CSS for the modals and saved contracts view
const modalStyles = {
    darkModal: {
      backgroundColor: 'rgba(20, 20, 20, 0.95)',
      color: '#ffffff',
      borderRadius: '10px',
      border: '1px solid rgba(79, 209, 197, 0.2)',
    },
    darkModalHeader: {
      backgroundColor: 'rgba(30, 30, 30, 0.95)',
      color: '#ffffff',
      borderBottom: '1px solid rgba(79, 209, 197, 0.2)',
    },
    darkModalBody: {
      backgroundColor: 'rgba(20, 20, 20, 0.95)',
      color: '#ffffff',
      padding: '20px',
    },
    darkModalFooter: {
      backgroundColor: 'rgba(30, 30, 30, 0.95)',
      borderTop: '1px solid rgba(79, 209, 197, 0.2)',
    },
    darkListItem: {
      backgroundColor: 'rgba(30, 30, 30, 0.6)',
      color: '#ffffff',
      border: '1px solid rgba(79, 209, 197, 0.1)',
      marginBottom: '10px',
      borderRadius: '8px',
    }
  };

  export default modalStyles;
  